import { clamp } from "@utils/utils";

export function BiquadMagnitude(type: string, fc: number, q: number, freq: number): number {
  const normFreq = freq / Math.max(fc, 1);
  const safeQ = Math.max(q, 0.01);
  const denom = Math.sqrt(Math.pow(1 - normFreq * normFreq, 2) + Math.pow(normFreq / safeQ, 2));
  switch (type) {
    case "lowpass":
      return 1 / denom;
    case "highpass":
      return (normFreq * normFreq) / denom;
    case "bandpass":
      return normFreq / safeQ / denom;
    case "notch":
      return Math.abs(1 - normFreq * normFreq) / denom;
    default:
      return 1;
  }
}

export function NormalizedToHz(norm: number, fMin: number, fMax: number): number {
  return clamp(norm * fMax, fMin, fMax);
}

export function HzToNormalized(hz: number, fMax: number, min: number, max: number): number {
  return clamp(hz / fMax, min, max);
}

export function ResonanceToQ(resonance: number, resonanceMax: number, qMin: number, qMax: number) {
  return qMin + (resonance / resonanceMax) * (qMax - qMin);
}

export function QToResonance(
  q: number,
  qMin: number,
  qMax: number,
  resonanceMin: number,
  resonanceMax: number,
): number {
  return clamp(((q - qMin) / (qMax - qMin)) * resonanceMax, resonanceMin, resonanceMax);
}

export function PhaserNotchQ(feedback: number): number {
  return 1 + feedback * 19;
}

export function OctaveSpan(
  baseHz: number,
  octaves: number,
  fMin: number,
  fMax: number,
): { lowHz: number; highHz: number } {
  return { lowHz: baseHz, highHz: clamp(baseHz * Math.pow(2, octaves), fMin, fMax) };
}
